import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'
import VueObserveVisibility from 'vue-observe-visibility'
import PortalVue from 'portal-vue'
import Wizer from '@wizer/core'
import LocalStorageKeys from '@/constants/LocalStorageKeys'
import App from './App.vue'
import router from './router'
import store from './store/store'

import '@/assets/css/tailwind.css'

Vue.use(VueLocalStorage)
Vue.use(VueObserveVisibility)
Vue.use(PortalVue)

const localeToUse =
  process.env.VUE_APP_E360_LOCALE || Vue.localStorage.get(LocalStorageKeys.E360_LOCALE, 'en-AU')

const personDetails = JSON.parse(
  process.env.VUE_APP_E360_PERSON_DETAILS || Vue.localStorage.get(LocalStorageKeys.PERSON_DETAILS),
)

Object.defineProperty(Vue.prototype, '$profile', {
  value: {
    locale: localeToUse,
    name: personDetails?.personName,
    id: personDetails?.personId,
  },
})

Vue.use(Wizer, {
  components: false,
  store,
  labels: {
    locale: localeToUse,
  },
  formConfig: {
    asteriskPlacement: 'left',
  },
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
